import { render, staticRenderFns } from "./twoLevel.vue?vue&type=template&id=ab56e3e0&scoped=true&"
import script from "./twoLevel.vue?vue&type=script&lang=js&"
export * from "./twoLevel.vue?vue&type=script&lang=js&"
import style0 from "./twoLevel.vue?vue&type=style&index=0&id=ab56e3e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab56e3e0",
  null
  
)

export default component.exports